(function () {
  function initTabs(root) {
    if (!root || root.dataset.tabsReady === 'true') return;

    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    var panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    function activate(btn) {
      tabs.forEach(function (tab) {
        var active = tab === btn;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var show = panel.id === btn.dataset.panel;
        panel.style.display = show ? 'block' : 'none';
        panel.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab);
      });
    });

    root.dataset.tabsReady = 'true';
  }

  document.querySelectorAll('[data-support-tabs]').forEach(initTabs);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-support-tabs]').forEach(initTabs);
  });
})();
